/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { mediaBreakpoints } from '../../../common/responsive';
import { ContextualHelpListItem } from './ContextualHelpListItem';
import { ContextualHelpListItemModalTrigger } from './ContextualHelpListItemModalTrigger';
import { getTextScreenDefinition } from './contextualHelpUtils';

export interface ContextualHelp {
  linkText: string;
  textScreenId: string;
  onClick?: () => void;
}

export namespace ContextualHelpList {
  export interface Props {
    contextualHelps: ContextualHelp[];
  }
}

const styles = StyleSheet.create({
  linkTextWrapper: {
    fontSize: 16,
    [mediaBreakpoints.mobile]: {
      fontSize: 14,
    },
  },
});

export const ContextualHelpList: React.FC<ContextualHelpList.Props> = ({ contextualHelps }) => {
  return (
    <div data-it="ContextualHelpList">
      {contextualHelps.map((helpConfig: ContextualHelp) => {
        const { textScreenId } = helpConfig;
        const textScreenDefinition = getTextScreenDefinition(textScreenId);
        return (
          <ContextualHelpListItem
            renderTrigger={({ openModal }) => (
              <ContextualHelpListItemModalTrigger openModal={openModal} icon={'info-2'}>
                <span className={css(styles.linkTextWrapper)}>{textScreenDefinition.linkText}</span>
              </ContextualHelpListItemModalTrigger>
            )}
            textScreenId={textScreenId}
            textScreenDefinition={textScreenDefinition}
            key={textScreenId}
          />
        );
      })}
    </div>
  );
};
